var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.is_tag_set)?_vm._t("default"):_c('input-wrapper',[_c('p',{domProps:{"textContent":_vm._s(_vm.text)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }